import React from "react";

const ArticleCard = (props) => {
  return (
    <>
      <div class="flex flex-col max-w-md mx-auto py-0 rounded-xl space-y-2 my-4 hover:-translate-y-1 transition-all duration-500 pb-2 bg-gray-100">
        <img
          class="w-full rounded-t-xl h-48"
          src={props.img}
          alt="motivation"
        />
        <h1 class="font-semibold text-gray-900 text-left px-2 hover:underline ">
          May 28, 2022
        </h1>
        <a
          class="font-semibold text-gray-900 text-xl text-left px-2 hover:underline cursor-pointer"
          href={`/article/${props.id}`}
        >
          {props.title}
        </a>
        {/* <p class="leading-relaxed text-left text-ellipsis text-sm px-2 overflow-hidden">
          {props.description}
        </p> */}
      </div>
    </>
  );
};

export default ArticleCard;
